// @flow

import { h }             from "preact";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import { growIn,
         stutter,
         shortDuration,
         slideUp,
         slideLeft } from "../../helpers/animations";

import CopyIcon from "../../icons/copy.svg";

import Button   from "../Button";
import Message  from "../Message";
import Spinner  from "../Spinner";

export default class ItemCodesList extends PureComponent {
  props: Props;

  static defaultProps = {
    code : {},
    item : {},
  };

  render({ code, item, obtainedCodes, loading, order, ...props }: Props, state: any, { t }: Context) {
    if (!code) {
      return;
    }

    return (
      <ul class={classNames(
            this.props["class"],
            styles.block,
          )}>

        <li class={styles.item}>
          <div class={styles.header}>
            <h5 class={styles.name}>
              {item.product.name}
            </h5>

            <span class={styles.qty}>
              {t("SUCCESS.QTY", { qty: item.qty })}
            </span>
          </div>
        </li>

        {Array.apply(null, { length: item.qty }).map((_, i) =>
          <CodeItem
              code={code.codes && code.codes[i] ? code.codes[i] : null}
              loading={loading}
              stutterOffset={i * 2}
          />
        )}
      </ul>
    );
  };
};

class CodeItem extends PureComponent {
  static defaultProps = {
    stutterOffset : 0
  }

  setMessage = (message, status) => {
    this.setState({ copiedState: { message, status } });
    window.clearTimeout(this.messageTimeout);

    this.messageTimeout = setTimeout(() => {
      this.setState({ copiedState: null });
    }, 3000);
  }

  copyToClipboard = () => {
    window.getSelection().removeAllRanges();
      
    const range = document.createRange();

    range.selectNode(this.codeNode);
    window.getSelection().addRange(range);

    try {
      document.execCommand("copy");
      this.setMessage(this.context.t("CODES.COPY.SUCCESS"), "success");
    } catch(err) {
      this.setMessage(this.context.t("CODES.COPY.FAILURE"), "error");
    }

    setTimeout(() => window.getSelection().removeAllRanges(), 0);
  };

  render({ code, loading, stutterOffset, ...props }: Props, { copiedState }: any, { formatDate, t }: Context) {
    if (code) {
      return (
        <li {...props}
            class={styles.item}>

          <div
              class={classNames(
                styles.row,
                {[styles.highlight]: copiedState}
              )}>

            <div class={styles.column}>
              <div
                  style={stutter(stutterOffset)}
                  class={classNames(
                    styles.codeArea,
                    slideUp
                  )}>

                <span
                    class={styles.code}
                    ref={elem => this.codeNode = elem}
                    dangerouslySetInnerHTML={{ __html: code.code }}
                />
              </div>

              <span
                  style={stutter(1 + stutterOffset)}
                  class={classNames(
                    styles.expires,
                    slideUp
                  )}>

                {t("CODES.VALID_TO", {
                  date: formatDate(code.expiryDate)
                })}
              </span>
            </div>

            <div class={styles.column}>
              <Button
                  modifiers="thin"
                  disabled={copiedState}
                  title={t("CODES.COPY.TITLE")}
                  onClick={this.copyToClipboard}
                  style={stutter(2 + stutterOffset)}
                  class={classNames(
                    styles.button,
                    growIn
                  )}>

                <CopyIcon class={styles.icon} />
              </Button>

              {copiedState ?
                <Message
                    status={copiedState.status}
                    class={classNames(
                      styles.message,
                      slideLeft,
                      shortDuration
                    )}>

                  {copiedState.message}
                </Message>
              : null}
            </div>
          </div>
        </li>
      );
    }

    return (
      <li {...props}
          class={styles.item}>

        <div class={styles.row}>
          <div class={styles.column}>
            <p class={styles.paragraph}>
              {loading ?
                t("CODES.LOADING") :
                t("CODES.NO_CODE")}
            </p>
          </div>

          {loading ?
            <div class={styles.column}>
              <Spinner />
            </div>
          : null}
        </div>
      </li>
    );
  }
}
